import clsx from 'clsx'
import {
  GenericErrorBoundary,
  LeftSideBar,
  Navigation,
  Rule,
  Tabs,
  UserMenuTopBar
} from 'components/core-v2'
import { FC } from 'react'

import { NotesFilters } from '../../components/notes-filters'
import { NotesFoundBar } from '../../components/notes-found-bar'
import { ReportingPageTabs } from '../../components/top-level-tabs'
import classes from './index.module.scss'

interface Props {
  backgroundColor: 'grey' | 'white'
  tabValue: string
  withOverflow: boolean
  withPadding: boolean
}
const Main: FC<Props> = ({ backgroundColor, children, tabValue, withOverflow, withPadding }) => (
  <>
    <NotesFoundBar />
    <ReportingPageTabs />
    <Rule className={classes.rule} />
    <main
      className={clsx(classes.main, {
        [classes.backgroundGrey]: backgroundColor === 'grey',
        [classes.backgroundWhite]: backgroundColor === 'white',
        [classes.withPadding]: withPadding,
        [classes.withOverflow]: withOverflow
      })}
    >
      <Tabs.Panel className={clsx(classes.panel, 'flex-1', 'flex', 'flex-column')} value={tabValue}>
        {children}
      </Tabs.Panel>
    </main>
  </>
)

export const ReportingTemplate: FC<Props> = ({
  backgroundColor,
  children,
  tabValue,
  withOverflow,
  withPadding
}) => (
  <GenericErrorBoundary>
    <LeftSideBar
      leftElement={<Navigation />}
      mainElement={
        <GenericErrorBoundary>
          <Main
            backgroundColor={backgroundColor}
            tabValue={tabValue}
            withOverflow={withOverflow}
            withPadding={withPadding}
          >
            {children}
          </Main>
        </GenericErrorBoundary>
      }
      topBarElement={<UserMenuTopBar leftElement={<NotesFilters />} />}
    />
  </GenericErrorBoundary>
)
